// Types
import type {
  TAutomatedEmailOutboxApiRow,
  TOutboxEmail,
} from '~/modules/opportunities/automated-email/types';

// Config
import { TRIGGER_NAME_TO_LABEL } from '~/modules/opportunities/automated-email/outbox/models/config';

// Utils
import { capitalizeFirstWordLetter } from '~/misc/utils/text';

export function labelFromOutboxTriggerName(triggerName: string): string {
  const mapped: string | undefined = TRIGGER_NAME_TO_LABEL[triggerName];

  if (mapped !== undefined) {
    return mapped;
  }

  return triggerName
    .split('-')
    .filter(Boolean)
    .map((part: string): string => capitalizeFirstWordLetter(part))
    .join(' ');
}

export function mapAutomatedEmailOutboxApiRow(row: TAutomatedEmailOutboxApiRow): TOutboxEmail {
  return {
    id: row.id,
    opportunity_id: row.opportunity_id,
    contact_id: row.contact_id,
    listing_id: row.listing_id,
    address_id: row.address_id,
    listing_beds: row.listing_beds,
    listing_category: row.listing_category,
    listing_price: row.listing_price,
    listing_status_id: row.listing_status_id,
    listing_address: row.listing_address,
    opportunity_property_beds: row.opportunity_property_beds,
    opportunity_property_category: row.opportunity_property_category,
    opportunity_property_price: row.opportunity_property_price,
    opportunity_property_address: row.opportunity_property_address,
    patch_id: row.patch_id,
    sale_type: row.sale_type,
    contact_name: row.contact_name,
    contact_email: row.contact_email,
    property_address: row.property_address ?? row.opportunity_property_address ?? '',
    trigger_name: row.trigger_name,
    trigger: labelFromOutboxTriggerName(row.trigger_name),
    subject: row.subject,
    content: row.content,
    send_at: row.send_at,
    created_at: row.created_at,
    status: row.status,
  };
}
